class SelectorContinents {
	constructor() {
		this.container = document.querySelector('.list-continents');
		if (!this.container) return;

		this.filters = this.container.querySelectorAll('.continent-filter');
		this.init();
		this.handleResize(); // Ejecutar una vez al principio
		window.addEventListener('resize', this.handleResize.bind(this)); // Escuchar resize
	}

	init() {
		this.filters.forEach(filter => {
			filter.addEventListener('click', () => {
				// Solo aplicar lógica si la pantalla es 768px o menor
				if (window.innerWidth <= 768) {
					if (filter.classList.contains('active')) {
						this.filters.forEach(f => f.style.display = 'flex');
					} else {
						this.filters.forEach(f => {
							f.classList.remove('active');
							f.style.display = 'none';
						});
						filter.classList.add('active');
						filter.style.display = 'flex';
					}
				}
			});
		});
	}

	handleResize() {
		if (window.innerWidth > 768) {
			this.filters.forEach(f => f.style.display = 'block');
		} else {
			this.filters.forEach(f => {
				if (f.classList.contains('active')) {
					f.style.display = 'flex';
				} else {
					f.style.display = 'none';
				}
			});
		}
	}
}

export default SelectorContinents;
